<template>
  <div class="tab-content-frame" :class="{ active : isActive }">
    <slot></slot>
  </div>
</template>

<script>

  export default {

    data() {
      return {
        isActive: false,
        hash: window.location.hash
      }
    },

    computed: {
      href() {
        return '#' + this.name.toLowerCase().replace(/ /g, '-');
      },
      requested() {
        return this.hash.replace(/-/g, ' ').substring(1);
      }
    },

    mounted() {
      if (this.requested == this.name) {
        this.isActive = true;
      } else if(this.requested !== this.name) {
        this.isActive = false
      }

      if (!this.requested){
        this.isActive = this.selected
      }
    },

    props: {
      name: { required: true },
      selected: { default: false },
      requested: { default: ''}
    }

  }


</script>